<template>
    <div class="grid gap-6" :class="gridColsClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'IntContentGrid',
        
        props: {
          columns: { type: [Number, Object] }
        },

        computed: {
          gridColsClass() {
            if (this.columns) {
              if (typeof this.columns === 'object') {
                let gridClasses = []
                
                for (const [key, value] of Object.entries(this.columns)) {
                  if (key === 'default') { gridClasses.push(`grid-cols-${value}`) }
                  else { gridClasses.push(`${key}:grid-cols-${value}`) }
                }
                
                return gridClasses
              }
              else {
                return 'grid-cols-' + this.columns
              }
            }
          }
        }
    }
</script>